module.exports = __webpack_public_path__ + "img/title_txt_day1.fd688936.png";